import Vue from 'vue';
import './plugins/fontawesome';
import VueGtm from 'vue-gtm'; // temporary GTM disabled
import VueRouter from 'vue-router';
import Meta from 'vue-meta';

import Vue2TouchEvents from 'vue2-touch-events';
import moment from 'moment';
import GlobalEvents from 'vue-global-events';
import LazySizes from 'lazysizes';

// Vue-click-outside
import vClickOutside from 'vue-click-outside';

// Vee-Validate
import VeeValidate from 'vee-validate';

// Vue tel input for flag phonenumbers
// import 'vue-tel-input/dist/vue-tel-input.css';
// import VueTelInput from 'vue-tel-input';

// Underscore
import underscore from 'vue-underscore';

// Vimeo
// import Vimeo from 'vimeo';

// UI / shared
import VueCookies from 'vue-cookies-reactive';
import VueSocialSharing from 'vue-social-sharing';
import InstantSearch from 'vue-instantsearch';
import VueTippy, { TippyComponent } from 'vue-tippy';
import Area from './components/Area.vue';
import AppLink from './components/AppLink.vue';
import Accordion from './components/Accordion.vue';

// DATE PICKER

// Components
import Searchvilla from './components/Searchvilla';

// Addons

// Social Sharing

// Directives
import LazyLoadDirective from './directives/Lazyload.vue';

// Algolia instant search
import store from './store/store';
import App from './App.vue';

Vue.use(VueSocialSharing);
Vue.directive('lazyload', LazyLoadDirective);
Vue.use(InstantSearch);

// import 'roboto-fontface/css/roboto/roboto-fontface.css'

require('matchmedia-polyfill');
require('matchmedia-polyfill/matchMedia.addListener');

// Vue configuration
/* eslint-disable no-new */
Vue.config.silent = false;
Vue.config.performance = true;
Vue.config.productionTip = true;
// Vue.config.devtools = true

// Underscore
Vue.use(underscore);
Vue.use(vClickOutside);
// needed to validate numeric fields without the default decimal validation which is a bug from vee-validate as it attaches this to each field with type number
Vue.use(VeeValidate, {
  useConstraintAttrs: false,
});
Vue.use(VueRouter);

// GTM (for google analytics) // temporary GTM disabled
Vue.use(VueGtm, {
  id: 'GTM-WD9Z68', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(Meta);
Vue.use(VueCookies);
// Vue.use(VueI18n)
Vue.use(Vue2TouchEvents, { swipeTolerance: 100 });
Vue.use(VueTippy);

Vue.use(VueTippy);

Vue.use(LazySizes);

// Vue.use(Vimeo);

// Define globally
// Components
Vue.component('Searchvilla', Searchvilla);
Vue.component('GlobalEvents', GlobalEvents);
Vue.component('app-link', AppLink);
Vue.component('Accordion', Accordion);
Vue.component('app-template-area', Area);
Vue.component('tippy', TippyComponent);

// Modules
Vue.component('app-module-html', (resolve) => {
  require(['./components/cms_modules/CMSHtml.vue'], resolve);
});
Vue.component('app-module-slideshow', (resolve) => {
  require(['./components/cms_modules/CMSSlideshow.vue'], resolve);
});
Vue.component('app-curated-page-list', (resolve) => {
  require(['./components/cms_modules/CMSCuratedPageList.vue'], resolve);
});

// Templates
Vue.component('app-template-loading', (resolve) => {
  require(['./pages/Loading.vue'], resolve);
});
Vue.component('app-template-home', (resolve) => {
  require(['./pages/Home.vue'], resolve);
});
// Vue.component('app-template-aritcle', (resolve) => {
//   require(['./pages/Article.vue'], resolve);
// });
Vue.component('app-template-fullwidth', (resolve) => {
  require(['./pages/FullWidth.vue'], resolve);
});
Vue.component('app-template-404', (resolve) => {
  require(['./pages/404.vue'], resolve);
});
Vue.component('app-template-results', (resolve) => {
  require(['./pages/Results.vue'], resolve);
});
Vue.component('app-template-villa', (resolve) => {
  require(['./pages/villa/Villa.vue'], resolve);
});
Vue.component('app-template-shared-shortlist', (resolve) => {
  require(['./pages/sharedshortlist/SharedShortlist.vue'], resolve);
});
Vue.component('app-template-enquiry', (resolve) => {
  require(['./pages/Enquiry.vue'], resolve);
});
Vue.component('app-template-tenreasons', (resolve) => {
  require(['./pages/TenReasons.vue'], resolve);
});
Vue.component('app-template-ourstory', (resolve) => {
  require(['./pages/OurStory.vue'], resolve);
});
Vue.component('app-template-team', (resolve) => {
  require(['./pages/Team.vue'], resolve);
});
Vue.component('app-template-thinkexquisite', (resolve) => {
  require(['./pages/ThinkExquisite.vue'], resolve);
});
Vue.component('app-template-thinkexperiences', (resolve) => {
  require(['./pages/ThinkExperiences.vue'], resolve);
});
Vue.component('app-template-aboutus', (resolve) => {
  require(['./pages/AboutUs.vue'], resolve);
});
Vue.component('app-template-feedback', (resolve) => {
  require(['./pages/feedback/Feedback.vue'], resolve);
});
Vue.component('app-template-guide', (resolve) => {
  require(['./pages/Guide.vue'], resolve);
});
Vue.component('app-template-regions', (resolve) => {
  require(['./pages/Regions.vue'], resolve);
});
Vue.component('app-template-villacollections', (resolve) => {
  require(['./pages/VillaCollections.vue'], resolve);
});
Vue.component('app-template-weather', (resolve) => {
  require(['./pages/Weather.vue'], resolve);
});
Vue.component('app-template-experience', (resolve) => {
  require(['./pages/experience/Experience.vue'], resolve);
});
Vue.component('app-template-pressarticle', (resolve) => {
  require(['./pages/PressArticle.vue'], resolve);
});
Vue.component('app-template-presscoverage', (resolve) => {
  require(['./pages/PressCoverage.vue'], resolve);
});
Vue.component('app-template-regionthinkexperiences', (resolve) => {
  require(['./pages/RegionThinkExperiences.vue'], resolve);
});
Vue.component('app-template-greekislands', (resolve) => {
  require(['./pages/GreekIslands.vue'], resolve);
});
Vue.component('app-template-country', (resolve) => {
  require(['./pages/Country.vue'], resolve);
});
Vue.component('app-template-reviews', (resolve) => {
  require(['./pages/ClientReviews.vue'], resolve);
});
Vue.component('app-template-newsletter', (resolve) => {
  require(['./pages/NewsletterSignup.vue'], resolve);
});
Vue.component('app-experience-group-tier', (resolve) => {
  require(['./pages/experience/ExperienceGroupTier.vue'], resolve);
});
Vue.component('Greece', (resolve) => {
  require(['./pages/Greece.vue'], resolve);
});
Vue.component('app-template-travelagents', (resolve) => {
  require(['./pages/TravelAgents.vue'], resolve);
});
Vue.component('app-owner', (resolve) => {
  require(['./pages/Owner.vue'], resolve);
});

Vue.component('app-template-builder', (resolve) => {
  require(['./pages/Builder.vue'], resolve);
});
Vue.component('app-template-white-key', (resolve) => {
  require(['./pages/WhiteKey.vue'], resolve);
});
Vue.component('app-template-all-villas', (resolve) => {
  require(['./pages/AllVillas.vue'], resolve);
});

// cue.component('app-template-country', (resolve) => {
//   require(['./pages/Country.vue'], resolve)
// })
// Online booking
Vue.component('app-template-ob-summary', (resolve) => {
  require(['./pages/secure/onlinebooking/OBSummary.vue'], resolve);
});
Vue.component('app-template-ob-payment', (resolve) => {
  require(['./pages/secure/onlinebooking/OBPayment.vue'], resolve);
});

// Secure Client Area
Vue.component('app-template-clientarea-login', (resolve) => {
  require(['./pages/secure/clientarea/CALogin.vue'], resolve);
});
Vue.component('app-template-clientarea-dashboard', (resolve) => {
  require(['./pages/secure/clientarea/CADashboard.vue'], resolve);
});
Vue.component('app-template-clientarea-bookings', (resolve) => {
  require(['./pages/secure/clientarea/CABookings.vue'], resolve);
});
Vue.component('app-template-clientarea-profile', (resolve) => {
  require(['./pages/secure/clientarea/CAProfile/CAPersonalProfile.vue'], resolve);
});
Vue.component('app-template-clientarea-subscriptions', (resolve) => {
  require(['./pages/secure/clientarea/accountSettings/CAAccountSettings.vue'], resolve);
});
Vue.component('app-template-clientarea-guest-logins', (resolve) => {
  require(['./pages/secure/clientarea/CAGuestLogins.vue'], resolve);
});
Vue.component('app-template-clientarea-experiences', (resolve) => {
  // require(['./pages/secure/clientarea/CAExperiences.vue'], resolve);
  require(['./pages/secure/clientarea/CAExperiencesNew.vue'], resolve);
});
Vue.component('app-template-clientarea-experiences-basket', (resolve) => {
  require(['./pages/secure/clientarea/experiences/ExperienceBasket.vue'], resolve);
});
Vue.component('app-template-clientarea-experiences-checkout', (resolve) => {
  require(['./pages/secure/clientarea/experiences/ExperienceCheckout.vue'], resolve);
});
Vue.component('app-template-clientarea-booking-conditions', (resolve) => {
  require(['./pages/secure/clientarea/CABookingConditions.vue'], resolve);
});
Vue.component('app-template-clientarea-privacy-policy', (resolve) => {
  require(['./pages/secure/clientarea/CAPrivacyPolicy.vue'], resolve);
});
Vue.component('app-template-clientarea-FAQ', (resolve) => {
  require(['./pages/secure/clientarea/CAFaq.vue'], resolve);
});
Vue.component('app-template-clientarea-weather', (resolve) => {
  require(['./pages/secure/clientarea/CAWeather.vue'], resolve);
});
Vue.component('app-template-clientarea-carhire', (resolve) => {
  require(['./pages/secure/clientarea/CACarhire.vue'], resolve);
});
Vue.component('app-template-clientarea-bank-account-details', (resolve) => {
  require(['./pages/secure/clientarea/CABankAccountDetails.vue'], resolve);
});
Vue.component('app-template-threed', (resolve) => {
  require(['./pages/secure/threed.vue'], resolve);
});
Vue.component('ClientAreaVillaDepositThanks', (resolve) => {
  require(['./pages/secure/shared/VillaDepositPayThanks.vue'], resolve);
});
Vue.component('ClientAreaVillaBalanceThanks', (resolve) => {
  require(['./pages/secure/shared/VillaBalancePayThanks.vue'], resolve);
});
Vue.component('app-template-clientarea-transfers', (resolve) => {
  require(['./pages/secure/clientarea/CATransfers.vue'], resolve);
});
Vue.component('app-template-clientarea-transfers-basket', (resolve) => {
  require(['./pages/secure/clientarea/transfers/TransfersBasket.vue'], resolve);
});
Vue.component('app-template-clientarea-transfers-checkout', (resolve) => {
  require(['./pages/secure/clientarea/transfers/TransfersCheckout.vue'], resolve);
});
Vue.component('app-template-clientarea-transfers-complete-checkout', (resolve) => {
  require(['./pages/secure/clientarea/transfers/TransfersCompleteCheckout.vue'], resolve);
});
Vue.component('app-template-clientarea-billing', (resolve) => {
  require(['./pages/secure/clientarea/CABilling.vue'], resolve);
});

// Secure Client Area - Confirmed area
Vue.component('app-template-clientarea-confirmed-order-wine', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/CAWine/CAConfirmedOrderWine.vue'], resolve);
});
Vue.component('app-template-clientarea-confirmed-order-wine-step-2', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/CAWine/CAConfirmedOrderWineStep2.vue'], resolve);
});
Vue.component('app-template-clientarea-confirmed-order-wine-pay', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/CAWine/CAConfirmedOrderWinePay.vue'], resolve);
});
Vue.component('app-template-clientarea-confirmed-overview', (resolve) => {
  require(['./pages/secure/clientarea/CAViewBooking/CABookingOverview.vue'], resolve);
});
Vue.component('app-template-clientarea-confirmed-summary', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/CACOnfirmedSummary.vue'], resolve);
});
Vue.component('app-template-clientarea-confirmed-payment', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/CAConfirmedPayment.vue'], resolve);
});

// Secure Client Area - Provisional - Payments
Vue.component('app-template-clientarea-provisional-summary', (resolve) => {
  require(['./pages/secure/clientarea/provisional/CAProvisionalSummary.vue'], resolve);
});
Vue.component('app-template-clientarea-provisional-payment', (resolve) => {
  require(['./pages/secure/clientarea/provisional/CAProvisionalPayment.vue'], resolve);
});
Vue.component('app-template-flights-and-ferries', (resolve) => {
  require(['./pages/secure/clientarea/confirmed/FlightsAndFerries.vue'], resolve);
});

// Blogs
Vue.component('app-template-blog-home', (resolve) => {
  require(['./pages/blog/BlogHome.vue'], resolve);
});

Vue.component('app-template-blog-tag-category-home', (resolve) => {
  require(['./pages/blog/BlogTagCategoryHome.vue'], resolve);
});

Vue.component('app-template-blog-article', (resolve) => {
  require(['./pages/blog/BlogArticle.vue'], resolve);
});

// Filters
Vue.filter('firstCapitalLetter', (val) => val.charAt(0).toUpperCase() + val.slice(1));
Vue.filter('lowercase', (val) => val.toLowerCase());
Vue.filter('striphtml', (val) => {
  const regex = /(<([^>]+)>)/ig;
  return val.replace(regex, '');
});
Vue.filter('truncate', (val, length) => {
  if (val.length <= length || length == null) {
    return val;
  }
  return `${val.substring(0, length)}...`;
});

Vue.filter('formatTab', (val) => moment(val).format('DD MM YYYY'));

Vue.filter('toComma', (val) => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
  },
});

window.vue1 = new Vue({
  store,
  router,
  components: {
    GlobalEvents: window.VueGlobalEvents,
  },
  created() {
    window.$router = this.$router;
    window.moment = moment;
    this.checkCookieNotice();
    this.checkCookieStay();
    this.checkCookieNewDestinationViewed();
  },
  mounted() {
    // console.log('this.$vuetify.breakpoint', this.$vuetify.breakpoint)
  },
  methods: {
    checkCookieNotice() {
      if (window.$cookies.get('closeCookieNotice')) {
        this.$store.commit('common/closeCookieNotice', false);
      } else {
        this.$store.commit('common/closeCookieNotice', true);
      }
    },
    checkCookieStay() {
      window.$cookies.get('stayCookie') ? this.$store.commit('common/setStayCookie', false) : this.$store.commit('common/setStayCookie', true);
    },
    checkCookieNewDestinationViewed() {
      window.$cookies.get('WKDestinationPopupViewed') ? this.$store.commit('common/setCookieNewDestinationViewed', window.$cookies.get('WKDestinationPopupViewed')) : false;
    },
  },
  render: (h) => h(App),
}).$mount('#app');
